import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Location } from "@/data/mockWarehousesLocations";
import { AlertTriangle } from "lucide-react";

interface DeactivateLocationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  location: Location | null;
  onConfirm: () => void;
}

export function DeactivateLocationDialog({ open, onOpenChange, location, onConfirm }: DeactivateLocationDialogProps) {
  if (!location) return null;

  const hasStock = location.currentStock > 0;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Deactivate Location?</AlertDialogTitle>
          <AlertDialogDescription className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="rounded-full bg-yellow-100 dark:bg-yellow-900/30 p-2 mt-1">
                <AlertTriangle className="h-5 w-5 text-yellow-600 dark:text-yellow-400" />
              </div>
              <div className="flex-1">
                <p className="text-sm mb-3">
                  Are you sure you want to deactivate location <strong className="font-mono">{location.locationCode}</strong>?
                </p>
                {hasStock && (
                  <div className="p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-md">
                    <p className="text-sm text-yellow-800 dark:text-yellow-200 flex items-start gap-2">
                      <AlertTriangle className="h-4 w-4 mt-0.5 flex-shrink-0" />
                      <span>
                        This location currently has <strong>{location.currentStock}</strong> units of stock.
                        Consider moving stock before deactivating.
                      </span>
                    </p>
                  </div>
                )}
                <p className="text-sm mt-3 text-muted-foreground">
                  You can reactivate this location later if needed.
                </p>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-yellow-600 hover:bg-yellow-700">
            Deactivate
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
